import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tooltip, Typography } from '@mui/material';
import { EmojiTransportation, CalendarToday, CreditCard } from '@mui/icons-material';
import { InsuranceSummaryContainer, InsuranceSummaryItemContainer } from './InsuranceStyles';

const InsuranceSummary = ({ insurerName, insuranceAmount, currencyCode, periodicity }) => {
  const { t } = useTranslation();

  return (
    <InsuranceSummaryContainer container mt={1} spacing={1}>
      <InsuranceSummaryItemContainer item container width={'30%'}>
        <Tooltip title={t('Offer.Insurance.Insurer')}>
          <EmojiTransportation />
        </Tooltip>
        <Typography variant='caption' ml={1}>
          {insurerName}
        </Typography>
      </InsuranceSummaryItemContainer>
      <InsuranceSummaryItemContainer item container width={'30%'}>
        <Tooltip title={t('Offer.Insurance.QuotationValue', { currency: currencyCode })}>
          <CreditCard color='success' />
        </Tooltip>
        <Typography variant='caption' color='success' fontWeight='bold' ml={1}>
          {t('DECIMAL', { number: insuranceAmount })} {currencyCode}
        </Typography>
      </InsuranceSummaryItemContainer>
      <InsuranceSummaryItemContainer item container width={'30%'}>
        <Tooltip title={t('Offer.Insurance.PaymentPeriodicity')}>
          <CalendarToday />
        </Tooltip>
        <Typography variant='caption' ml={1}>
          <span>{periodicity} </span>
          <span>{periodicity === 1 ? t('Offer.Insurance.Month') : t('Offer.Insurance.Months')}</span>
        </Typography>
      </InsuranceSummaryItemContainer>
    </InsuranceSummaryContainer>
  );
};

InsuranceSummary.propTypes = {
  insurerName: PropTypes.string,
  insuranceAmount: PropTypes.number,
  currencyCode: PropTypes.string,
  periodicity: PropTypes.number
};

export default InsuranceSummary;
